import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { lighten } from "@mui/system";
import { contentBreakPoint, contentWidth } from "./types";
import { Colors } from "../../styles";

const menuBarBackgroundColor = lighten(Colors.Deverto, 0.2);

export const Root = styled(Box)({
    display: "flex",
    height: "100%",
    alignItems: "center",
    flexDirection: "column",
});

export const MainFrame = styled(Box)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    padding: "0 1em",
    [`@media (min-width: ${contentBreakPoint}px)`]: {
        maxWidth: contentWidth,
    },
});

export const Content = styled(Box)({
    padding: "0.5em 0",
});

export const MenuBar = styled(Box)({
    padding: "0.1em 0.3em 0.1em 0.7em",
    width: "100%",
    [`@media (min-width: ${contentBreakPoint}px)`]: {
        maxWidth: contentWidth,
    },
    "& a,span": {
        marginRight: "0.5em",
        textTransform: "none",
        fontSize: "1.1em",
        color: "white",
    },
    display: "flex",
});

export const MenuBarContainer = styled(Box)({
    width: "100%",
    backgroundColor: menuBarBackgroundColor,
    display: "flex",
    justifyContent: "center",
});

export const Panel = styled(Box)({
    backgroundColor: Colors.Deverto,
    padding: "1em",
    width: "100%",
    textAlign: "center",
});
